import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { MOCK_STATUS, MOCK_URL_STOPOVERS, URL_STOPOVER } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRAStopoverService = /** @class */ (function () {
    function INDRAStopoverService(api, http) {
        this.api = api;
        this.http = http;
        this.confirmedStopovers = [];
    }
    INDRAStopoverService.prototype.getStopover = function (params) {
        if (MOCK_STATUS.STOPOVER) {
            return this.getMockData(params);
        }
        else {
            return this.api.INDRA_post(URL_STOPOVER, params);
        }
    };
    INDRAStopoverService.prototype.getMockStopover = function (params) {
        return this.getMockData(params);
    };
    INDRAStopoverService.prototype.getMockData = function (params) {
        return this.http.get(MOCK_URL_STOPOVERS);
    };
    INDRAStopoverService.prototype.isStopoverConfirmed = function (route, routeType) {
        return this.confirmedStopovers.find(function (stopOver) { return stopOver.route === route && stopOver[routeType]; });
    };
    INDRAStopoverService.prototype.clearStopoverConfirmed = function () {
        this.confirmedStopovers = [];
    };
    INDRAStopoverService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAStopoverService_Factory() { return new INDRAStopoverService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRAStopoverService, providedIn: "root" });
    return INDRAStopoverService;
}());
export { INDRAStopoverService };
